var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69043 12.4512V16.623H7.49512V5.24805H11.3857C12.0055 5.24805 12.5654 5.33919 13.0654 5.52148C13.5654 5.69857 13.9925 5.94596 14.3467 6.26367C14.6956 6.58659 14.9639 6.97201 15.1514 7.41992C15.3441 7.86784 15.4404 8.36523 15.4404 8.91211C15.4404 9.42253 15.3441 9.89388 15.1514 10.3262C14.9639 10.7585 14.6956 11.1309 14.3467 11.4434C13.9925 11.7611 13.5654 12.0085 13.0654 12.1855C12.5654 12.3626 12.0055 12.4512 11.3857 12.4512H9.69043ZM9.69043 10.6699H11.3857C11.6982 10.6699 11.9691 10.623 12.1982 10.5293C12.4274 10.4355 12.6201 10.3079 12.7764 10.1465C12.9274 9.98503 13.0394 9.80013 13.1123 9.5918C13.1904 9.37826 13.2295 9.1569 13.2295 8.92773C13.2295 8.66211 13.1904 8.41471 13.1123 8.18555C13.0394 7.95638 12.9274 7.75586 12.7764 7.58398C12.6201 7.41211 12.4274 7.27669 12.1982 7.17773C11.9691 7.07878 11.6982 7.0293 11.3857 7.0293H9.69043V10.6699Z",
    fill: "url(#paint0_linear_7591_3163)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0846 21.248V20.1401L15.6734 17.7431C15.8936 17.53 16.0782 17.3382 16.2274 17.1678C16.3789 16.9973 16.4937 16.8304 16.5718 16.6671C16.6499 16.5014 16.689 16.3226 16.689 16.1309C16.689 15.9178 16.6405 15.7343 16.5434 15.5804C16.4463 15.4242 16.3138 15.3046 16.1457 15.2218C15.9776 15.1365 15.787 15.0939 15.574 15.0939C15.3514 15.0939 15.1573 15.1389 14.9916 15.2289C14.8258 15.3188 14.698 15.4479 14.608 15.6159C14.5181 15.784 14.4731 15.9841 14.4731 16.2161H13.0136C13.0136 15.7402 13.1213 15.3271 13.3367 14.9767C13.5522 14.6264 13.854 14.3553 14.2423 14.1635C14.6305 13.9718 15.078 13.8759 15.5846 13.8759C16.1054 13.8759 16.5588 13.9682 16.9447 14.1529C17.3329 14.3352 17.6348 14.5885 17.8502 14.9128C18.0657 15.2372 18.1734 15.6088 18.1734 16.0279C18.1734 16.3025 18.1189 16.5736 18.01 16.8411C17.9035 17.1086 17.7129 17.4057 17.4383 17.7324C17.1637 18.0568 16.7766 18.4462 16.2771 18.9007L15.2153 19.9412V19.9909H18.2693V21.248H13.0846ZM20.8678 13.9753L22.3344 16.454H22.3912L23.865 13.9753H25.6015L23.382 17.6117L25.6512 21.248H23.8827L22.3912 18.7658H22.3344L20.843 21.248H19.0816L21.3579 17.6117L19.1242 13.9753H20.8678Z",
    fill: "url(#paint1_linear_7591_3163)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.2473C0 5.46055 4.70859 0.751953 10.4953 0.751953C16.282 0.751953 20.9906 5.46055 20.9906 11.2473C20.9906 11.5848 20.9746 11.9186 20.9433 12.248H19.1782C19.2158 11.9196 19.2352 11.5856 19.2352 11.2473C19.2352 6.42852 15.3141 2.50742 10.4953 2.50742C5.67656 2.50742 1.75547 6.42852 1.75547 11.2473C1.75547 16.066 5.67656 19.9871 10.4953 19.9871C10.8333 19.9871 11.167 19.9678 11.4951 19.9303V21.6953C11.166 21.7266 10.8325 21.7426 10.4953 21.7426C4.70859 21.7426 0 17.034 0 11.2473Z",
    fill: "url(#paint2_linear_7591_3163)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7591_3163",
    x1: 7.49512,
    y1: 10.9355,
    x2: 15.4404,
    y2: 10.9355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FCD763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F3EAC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4B742"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7591_3163",
    x1: 12.4951,
    y1: 17.248,
    x2: 26.4951,
    y2: 17.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FCD763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F3EAC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4B742"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7591_3163",
    x1: 0,
    y1: 11.2473,
    x2: 20.9906,
    y2: 11.2473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FCD763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#F3EAC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F4B742"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleX);
export default __webpack_public_path__ + "static/media/doubleX.4d17dc2736f22b95ab650dadb69ba6fb.svg";
export { ForwardRef as ReactComponent };